/** @format */

import template from './gb-raffle-item-amount-label.html';
import './gb-raffle-item-amount-label.scss';

export const GbRaffleItemAmountLabelComponent = {
    template,
    controller: class GbRaffleItemAmountLabelComponent {
        constructor() {
            'ngInject';
        }
    },
};
